import React from "react";
import { Link } from "react-router-dom";
import LegalDocument from "../../components/LegalDocument/LegalDocument";

const PrivacyPolicyPage = () => {
  return (
    <LegalDocument
      title="Política de Privacidade"
      updatedAt="18/08/2026"
    >
      <p>
        LetsDoc — LET'S DOC TECNOLOGIA LTDA, CNPJ{" "}
        60.572.889/0001-03
      </p>

      <h2>1. Introdução</h2>
      <p>
        Esta Política de Privacidade descreve como{" "}
        LET'S DOC TECNOLOGIA LTDA ("Empresa", "nós") coleta,
        utiliza, armazena e protege dados pessoais no âmbito da plataforma
        LetsDoc, em conformidade com a Lei Geral de Proteção de Dados (Lei nº
        13.709/2018 — LGPD).
      </p>
      <p>
        Esta política se aplica a dois grupos de titulares de dados: (a) os
        profissionais de saúde e demais usuários cadastrados na Plataforma
        ("Usuário"); e (b) os pacientes cujos dados são inseridos pelos
        Usuários no curso do uso do Serviço ("Pacientes").
      </p>

      <h2>2. Papéis: Controlador e Operador</h2>
      <p>
        Em relação aos dados dos Pacientes, o Usuário (médico) figura como
        Controlador dos dados pessoais, definindo as finalidades e a forma
        do tratamento no exercício de sua atividade profissional. A Empresa
        atua como Operadora, tratando esses dados exclusivamente em nome e
        conforme as instruções do Usuário, para viabilizar o funcionamento
        da Plataforma (armazenamento, geração de documentos, envio de
        e-mails solicitados pelo próprio Usuário).
      </p>
      <p>
        Em relação aos dados do próprio Usuário (cadastro, uso da
        Plataforma, cobrança), a Empresa atua como Controladora.
      </p>

      <h2>3. Dados Coletados</h2>
      <h3>3.1 Dados do Usuário (profissional)</h3>
      <ul>
        <li>
          Dados de identificação e contato: nome completo, e-mail, CRM,
          especialidade médica;
        </li>
        <li>
          Dados de conta: credenciais de autenticação (gerenciadas por
          provedor de identidade — Auth0), hospitais, empresas e reservas
          vinculados ao perfil;
        </li>
        <li>
          Dados de cobrança: plano contratado, status de pagamento,
          identificadores de cliente no provedor de pagamentos (Stripe) — a
          Empresa não armazena diretamente dados completos de cartão de
          crédito;
        </li>
        <li>
          Dados de uso: registros de acesso, ações realizadas na Plataforma,
          para fins de segurança, auditoria e melhoria do Serviço.
        </li>
      </ul>

      <h3>3.2 Dados de Pacientes (inseridos pelo Usuário)</h3>
      <ul>
        <li>
          Dados de identificação: nome, data de nascimento, sexo, CPF,
          número de carteirinha e operadora/convênio;
        </li>
        <li>
          Dados de saúde (dados sensíveis, nos termos do art. 5º, II, da
          LGPD): histórico clínico, indicação cirúrgica, procedimentos,
          CIDs, laudos e demais informações necessárias à elaboração dos
          documentos gerados pela Plataforma;
        </li>
        <li>
          Documentos: PDFs de guias, resumos e recursos gerados e/ou
          enviados através da Plataforma.
        </li>
      </ul>
      <p>
        Esses dados são inseridos exclusivamente pelo Usuário, sendo de sua
        responsabilidade assegurar a base legal adequada para o tratamento
        (execução de tratamento de saúde, tutela da saúde, consentimento do
        paciente, conforme o caso), nos termos do art. 11 da LGPD.
      </p>

      <h2>4. Finalidade do Tratamento</h2>
      <ul>
        <li>
          Viabilizar a criação, edição, armazenamento e envio de pedidos
          cirúrgicos, guias, resumos e recursos;
        </li>
        <li>Autenticar e gerenciar o acesso do Usuário à Plataforma;</li>
        <li>Processar pagamentos e gerenciar assinaturas de planos;</li>
        <li>
          Enviar documentos por e-mail aos destinatários (hospitais e demais
          contatos) expressamente indicados pelo Usuário;
        </li>
        <li>Cumprir obrigações legais e regulatórias aplicáveis;</li>
        <li>Melhorar a qualidade, segurança e desempenho do Serviço.</li>
      </ul>

      <h2>5. Compartilhamento de Dados</h2>
      <p>Os dados podem ser compartilhados com:</p>
      <ul>
        <li>
          Hospitais e demais destinatários expressamente selecionados pelo
          Usuário no momento do envio de documentos por e-mail;
        </li>
        <li>
          Provedores de infraestrutura e tecnologia que atuam como
          suboperadores da Empresa (ex.: provedor de autenticação — Auth0;
          provedor de pagamentos — Stripe; provedores de nuvem e e-mail
          transacional), sempre limitados ao necessário para a prestação do
          Serviço e sob obrigações contratuais de confidencialidade e
          segurança;
        </li>
        <li>
          Autoridades públicas, quando exigido por lei, ordem judicial ou
          requisição regulatória.
        </li>
      </ul>
      <p>
        A Empresa não comercializa dados pessoais de Usuários ou Pacientes
        com terceiros.
      </p>

      <h2>6. Armazenamento e Segurança</h2>
      <p>
        A Empresa adota medidas técnicas e administrativas razoáveis para
        proteger os dados pessoais contra acessos não autorizados e
        situações acidentais ou ilícitas de destruição, perda, alteração,
        comunicação ou difusão, incluindo controle de acesso por
        autenticação, uso de conexões criptografadas (HTTPS) e segregação de
        credenciais sensíveis (tokens de autenticação mantidos apenas em
        memória, nunca armazenados em texto plano no dispositivo do
        Usuário).
      </p>
      <p>
        Nenhum sistema é absolutamente seguro; em caso de incidente de
        segurança que possa acarretar risco ou dano relevante aos titulares,
        a Empresa comunicará a Autoridade Nacional de Proteção de Dados
        (ANPD) e os titulares afetados, conforme exigido pela LGPD.
      </p>

      <h2>7. Retenção e Eliminação dos Dados</h2>
      <p>
        Os dados pessoais são mantidos pelo período necessário ao
        cumprimento das finalidades para as quais foram coletados, ao
        cumprimento de obrigações legais e regulatórias (incluindo prazos de
        guarda de prontuário e documentação médica aplicáveis) e ao
        exercício regular de direitos em processos judiciais,
        administrativos ou arbitrais. Encerrada a finalidade e os prazos
        legais de retenção, os dados serão eliminados ou anonimizados, salvo
        hipóteses legais que autorizem sua conservação.
      </p>

      <h2>8. Direitos do Titular de Dados</h2>
      <p>
        Nos termos do art. 18 da LGPD, o titular dos dados pode solicitar,
        mediante requisição ao canal indicado na Seção 11:
      </p>
      <ul>
        <li>Confirmação da existência de tratamento;</li>
        <li>Acesso aos dados;</li>
        <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
        <li>
          Anonimização, bloqueio ou eliminação de dados desnecessários,
          excessivos ou tratados em desconformidade com a LGPD;
        </li>
        <li>
          Portabilidade dos dados a outro fornecedor de serviço, mediante
          requisição expressa;
        </li>
        <li>
          Eliminação dos dados pessoais tratados com o consentimento do
          titular, quando aplicável;
        </li>
        <li>Informação sobre entidades com as quais os dados foram compartilhados;</li>
        <li>Revogação do consentimento, quando esta for a base legal do tratamento.</li>
      </ul>
      <p>
        Solicitações relativas a dados de Pacientes inseridos por um Usuário
        devem ser direcionadas, preferencialmente, ao próprio profissional
        de saúde responsável pelo atendimento (Controlador desses dados),
        podendo a Empresa auxiliar no atendimento à solicitação na qualidade
        de Operadora.
      </p>

      <h2>9. Cookies e Tecnologias de Rastreamento</h2>
      <p>
        A Plataforma pode utilizar cookies e tecnologias similares
        estritamente necessárias ao funcionamento do Serviço (ex.:
        manutenção de sessão de autenticação) e, quando aplicável, cookies
        de desempenho para análise agregada de uso.{" "}
      </p>

      <h2>10. Transferência Internacional de Dados</h2>
      <p>
        Alguns dos provedores utilizados pela Empresa (Seção 5) podem
        processar dados em servidores localizados fora do Brasil. Nesses
        casos, a Empresa busca assegurar que tais transferências ocorram
        para países ou organismos internacionais que proporcionem grau de
        proteção de dados pessoais adequado ao previsto na LGPD, ou mediante
        garantias contratuais específicas com os fornecedores.{" "}
        Norte da Virgínia, EUA
      </p>

      <h2>11. Encarregado de Dados (DPO) e Contato</h2>
      <p>
        Para exercer os direitos previstos nesta Política, esclarecer
        dúvidas ou reportar incidentes de segurança, entre em contato com
        nosso Encarregado de Proteção de Dados (DPO):
      </p>
      <ul>
        <li>
          Nome: Silvio Alonso
        </li>
        <li>
          E-mail: suporte@letsdoc.ai
        </li>
      </ul>

      <h2>12. Alterações nesta Política</h2>
      <p>
        Esta Política poderá ser atualizada periodicamente para refletir
        mudanças legais, operacionais ou de funcionalidades da Plataforma. A
        versão vigente estará sempre disponível na Plataforma, com indicação
        da data da última atualização.
      </p>

      <hr className="legal-divider" />
      <p>
        Para saber como e por que utilizamos a Plataforma, consulte também
        nossos <Link to="/terms">Termos de Uso</Link>.
      </p>
    </LegalDocument>
  );
};

export default PrivacyPolicyPage;
